interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages = Array.from({ length: total }, (_, index) => index + 1);

  const btnBase =
    "flex h-9 min-w-9 items-center justify-center rounded-md border px-3 text-sm font-medium transition-colors";

  return (
    <nav className="mt-8 flex flex-wrap items-center justify-center gap-2" aria-label="分页导航">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, current - 1))}
        disabled={current === 1}
        className={`${btnBase} border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40`}
      >
        <i className="ri-arrow-left-s-line" />
        <span className="ml-1 hidden sm:inline">上一页</span>
      </button>

      {pages.map((page) => (
        <button
          key={page}
          type="button"
          onClick={() => onChange(page)}
          className={
            page === current
              ? `${btnBase} border-primary-600 bg-primary-600 text-background-50`
              : `${btnBase} border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-600`
          }
        >
          {page}
        </button>
      ))}

      <button
        type="button"
        onClick={() => onChange(Math.min(total, current + 1))}
        disabled={current === total}
        className={`${btnBase} border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40`}
      >
        <span className="mr-1 hidden sm:inline">下一页</span>
        <i className="ri-arrow-right-s-line" />
      </button>
    </nav>
  );
}